import React from "react";
import { stateToHTML } from "draft-js-export-html";

const options = {
  entityStyleFn: (entity) => {
    const entityType = entity.get("type").toLowerCase();
    if (entityType === "token") {
      const data = entity.getData();
      return {
        element: "span",
        attributes: {
          "data-token-uuid": entity.data.UUID,
          class:
            "border bg-primary-subtle bg-gradient border-primary-subtle rounded-1 p-0 px-1 align-baseline",
        },
        // style: {
        // Put styles here...
        // },
      };
    }
  },
};
const smsOptions = {
  inlineStyles: {
    // Override default element (`strong`).
    BOLD: { element: null },
    ITALIC: { element: null },
    UNDERLINE: { element: null },
    CODE: { element: null },
  },
  blockRenderers: {
    "header-one": (block) => `<p>${block.getText()}</p>`,
    "header-two": (block) => `<p>${block.getText()}</p>`,
    "header-three": (block) => `<p>${block.getText()}</p>`,
    "header-four": (block) => `<p>${block.getText()}</p>`,
    "header-five": (block) => `<p>${block.getText()}</p>`,
    "header-six": (block) => `<p>${block.getText()}</p>`,
    blockquote: (block) => `<p>${block.getText()}</p>`,
    "unordered-list-item": (block) => `<p>${block.getText()}</p>`,
    "ordered-list-item": (block) => `<p>${block.getText()}</p>`,
    "code-block": (block) => `<p>${block.getText()}</p>`,
  },
  entityStyleFn: (entity) => {
    const entityType = entity.get("type").toLowerCase();
    if (entityType === "token") {
      const data = entity.getData();
      return {
        element: "span",
        attributes: {
          "data-token-uuid": entity.data.UUID,
          class:
            "border bg-primary-subtle bg-gradient border-primary-subtle rounded-1 p-0 px-1 align-baseline",
        },
        // style: {
        //   backgroundColour:
        // },
      };
    }
  },
};

export default function EditorPreview({ contentState, previewType }) {
  const emailHTML = stateToHTML(contentState, options);
  const smsHTML = stateToHTML(contentState, smsOptions);

  return (
    <>
      {previewType === "sms" && (
        <div
          className="public-DraftEditor-content"
          dangerouslySetInnerHTML={{ __html: smsHTML }}
        />
      )}
      {previewType === "email" && (
        <div
          className="public-DraftEditor-content"
          dangerouslySetInnerHTML={{ __html: emailHTML }}
        />
      )}
    </>
  );
}
